import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import BreadCrumb from "../../../components/breadcrumbs/BreadCrumb";
import { BreadRoute } from "../../../components/breadcrumbs/BreadRoute";
import { RootState } from "../../../reducers/combineReducer";
import { createEventObject, EventParamTypes } from "../../../types/types";

export const EventDetailCard: React.FC = () => {
  const { eventName }: createEventObject = useSelector(
    (state: RootState) => state["eventState"]["eventDetails"]
  );
  const { id } = useParams<EventParamTypes>();

  return (
    <div className='container w-screen h-screen'>
      <BreadRoute>
        <BreadCrumb label={"menu"} link={"/eventmenu"} />
        <BreadCrumb label={"events"} link={"/events"} />
        <BreadCrumb label={`event ${id}`} link={`/events/${id}`} />
        <BreadCrumb
          label={`details`}
          link={`/events/${id}/details`}
          lastChild={true}
        />
      </BreadRoute>
      <div className='w-1/2 mx-auto py-5 my-10 bg-blue-200'>
        <span>{eventName}</span>
      </div>
    </div>
  );
};

export default EventDetailCard;
